import circledCheckmarkIcon from 'presentation/assets/icons/png/3x/circle-check-info@3x.png';
import Icon, { ICONSIZE } from 'presentation/components/Icon';
import PageDescription from 'presentation/components/PageDescription';
import ProgrammaticConversionTracking from 'presentation/components/ProgrammaticConversionTracking';
import SAFeatureView from 'presentation/components/SAFeatureView';
import TitleWithPrevPageLink from 'presentation/components/TitleWithPrevPageLink';

import { WizardStepsContainer } from 'presentation/components/WizardSteps';
import { parse } from 'query-string';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import {
  PROGRAMMATIC_CONVERSION_IMG_SRC,
  PROGRAMMATIC_CONVERSION_SCRIPT_SRC
} from 'tracking/programmaticTracking';
import { PsoOrderCompletionTracker } from '../../../tracking/PsoOrderCompletionScriptLoader';

const EmailConfirmedPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const urlParameters = parse(location.search);

  const [directOrder] = useState(urlParameters.type === 'order');

  useEffect(() => {
    if (typeof urlParameters.id === 'string') {
      PsoOrderCompletionTracker.emitDataById(urlParameters.id);
      PsoOrderCompletionTracker.loadAfterEmitData();
    }
  }, [urlParameters.id]);

  return (
    <Container className="pb-4 mb-5">
      <WizardStepsContainer />

      <TitleWithPrevPageLink title={t('pageEMailConfirmedTitle')} />

      <PageDescription>
        {directOrder
          ? t('pageEMailConfirmedDescriptionOrder')
          : t('pageEMailConfirmedDescriptionLead')}
      </PageDescription>

      <Row>
        <Col xs={12} className="my-3">
          <Icon iconSrc={circledCheckmarkIcon} size={ICONSIZE.xxlarge} alt="checkmark icon"></Icon>
        </Col>
      </Row>

      {directOrder ? (
        <>
          <SAFeatureView />

          <ProgrammaticConversionTracking
            programmaticConversionImgSrc={PROGRAMMATIC_CONVERSION_IMG_SRC}
            programmaticConversionScriptSrc={PROGRAMMATIC_CONVERSION_SCRIPT_SRC}
          />
        </>
      ) : undefined}
    </Container>
  );
};

export default EmailConfirmedPage;
